import { render, staticRenderFns } from "./FaceStencil.vue?vue&type=template&id=3ed0b826"
import script from "./FaceStencil.vue?vue&type=script&lang=js"
export * from "./FaceStencil.vue?vue&type=script&lang=js"
import style0 from "./FaceStencil.vue?vue&type=style&index=0&id=3ed0b826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports